import { getPrecedence } from '@Consts/status-box';

export default {
	methods: {
		getPrecedence,
		logic(status, fn, initialValue) {
			if (!this.filters.department.step || !status)
				return false;
			return this.filters.department.step.reduce((value, step) => fn(value, this.getPrecedence(step), status), initialValue);
		},
		isDone(status) {
			return this.logic(status, this.doneLogic, true);
		},
		isReady(status) {
			return this.logic(status, this.readyLogic, false);
		},
		isBehind(status) {
			return this.logic(status, this.behindLogic, true);
		},
		doneLogic(oldValue, precendenceArr, status) {
			return oldValue && !precendenceArr.includes(status);
		},
		readyLogic(oldValue, precendenceArr, status) {
			return oldValue || precendenceArr[0] === status;
		},
		behindLogic(oldValue, precendenceArr, status) {
			return oldValue && (precendenceArr[0] !== status && precendenceArr.slice(1).includes(status));
		}
	}
};
